module.exports = "../static/media/logo.79318552.png";